import RfiSettingsDrawer from './RfiSettingsDrawer.component';

export default RfiSettingsDrawer;
